import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackInformations } from 'src/app/utils/interfaces/new/back-informations.interface';
import { CreateOps } from 'src/app/utils/interfaces/new/CreateOps';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class OpsService {

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath;
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  async getDbInstanceList(): Promise<string[]> {
    try {
      const res = await this._http.get(this.apiUri + "/hypermed/ops/db-instances", this.httpOptions).toPromise();
      const instanceList = res.body as string[];
      return instanceList;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  async deployCabinet(ops: CreateOps): Promise<void> {
    try {
      const res = await this._http.post(this.apiUri + "/hypermed/cabinets/ops", ops, this.httpOptions).toPromise();
      // console.log(res.body);
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
